import React, { useRef, useState } from 'react'
import {
  Filter as FilterIcon,
  Sort as SortIcon,
} from 'core-system/Icons/Actions'
import SearchInput from 'core-system/SearchInput'
import styled from 'styled-components'
import AlternateButton from 'core-system/Button/AlternateButton'
import DropdownMenu from 'core-system/Dropdown-menu/DropdownMenu'
import FilterModel, { FilterModelProps } from './FilterModel'

const Container = styled.div`
  display: flex;
  height: 2.25rem;
  gap: 0.5rem;
`

export interface TableOperationsProps extends Partial<FilterModelProps> {
  handleSearch: (value: string) => void
  handleSearchClear: () => void
  onAscendingClick: () => void
  onDescendingClick: () => void
  isFilterButtonActive: boolean
  activeSortDirection: 'asc' | 'desc'
  isSearchActive: boolean
  searchValue: string
  setSearchValue: (value: string) => void
  trailingActions?: React.ReactNode
  showFilter?: boolean
}

const TableOperations = React.memo((props: TableOperationsProps) => {
  const {
    handleSearch,
    handleSearchClear,
    filters = [],
    onAscendingClick,
    onDescendingClick,
    handleApplyFilters,
    handleFiltersReset,
    isFilterButtonActive,
    activeSortDirection,
    isSearchActive,
    searchValue,
    setSearchValue,
    trailingActions,
    showFilter = true,
  } = props

  const sortMenuRef = useRef(null)
  const [isFilterMenuOpen, setIsFilterMenuOpen] = useState(false)

  return (
    <Container>
      {showFilter && (
        <AlternateButton
          startIcon={<FilterIcon />}
          active={isFilterButtonActive}
          onClick={() => setIsFilterMenuOpen(true)}
        >
          Filter
        </AlternateButton>
      )}
      <AlternateButton
        startIcon={<SortIcon />}
        ref={sortMenuRef}
        active={activeSortDirection === 'asc' || activeSortDirection === 'desc'}
      >
        Sort
      </AlternateButton>
      <DropdownMenu
        menuItems={[
          {
            label: 'Ascending',
            onClick: onAscendingClick,
            active: activeSortDirection === 'asc',
          },
          {
            label: 'Descending',
            onClick: onDescendingClick,
            active: activeSortDirection === 'desc',
          },
        ]}
        anchorRef={sortMenuRef}
        position='bottom'
      />
      {trailingActions}
      <SearchInput
        value={searchValue}
        barBg={isSearchActive ? 'colored' : 'white'}
        variant='small'
        placeholder='Search...'
        onsearchIconClick={() => handleSearch(searchValue)}
        onPressEnter={() => handleSearch(searchValue)}
        onclearSearch={handleSearchClear}
        onChange={(e) => setSearchValue(e.target.value)}
        width={400}
      />
      {showFilter && (
        <FilterModel
          open={isFilterMenuOpen}
          closeModal={() => setIsFilterMenuOpen(false)}
          filters={filters}
          handleApplyFilters={handleApplyFilters}
          handleFiltersReset={handleFiltersReset}
        />
      )}
    </Container>
  )
})

export default React.memo(TableOperations)
